/* eslint-disable react/prop-types */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import classnames from 'classnames';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSearchParam } from 'react-use';
import { ANONYMOUS_ORDER } from '../../../constants/alert';
import { LEAD_CHECKOUT } from '../../../constants/job';
import { MEMBERSHIP } from '../../../constants/membership';
import { PRODUCT_TYPE } from '../../../constants/product';
import { sendLead, setMembershipPriceId } from '../../../redux/actions';
import { createJob, updateJob, updateProjectName } from '../../../redux/actions/jobs';
import { showModal } from '../../../redux/actions/modal';
import { profileSelectors } from '../../../redux/selectors/profile';
import routes from '../../../routes/constants';
import text, { formatCurrency } from '../../../text';
import { getNowDate } from '../../../utilities/date';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff, isUserAnonymous, isUserUnderTrial, userHasValidMembership } from '../../../utilities/user';
import { SAVE_DRAFT_MODAL } from '../../modal/SaveDraftModal';
import { FORCE_JOB_UPDATE_MODAL } from '../../modal/forceJobUpdateModal';
import { STATUS } from '../../orderListing/consts';
import { MapViewContext } from '../mapViewContext';
import { ExpandedDetails } from './ExpandedDetails';
import { amplitudeTrack } from '../../../utilities';
import { AMPLITUDE_EVENTS } from '../../../constants/analytics';
var PAYMENT_FLOW = AMPLITUDE_EVENTS.PAYMENT_FLOW;
var ExpandableCheckoutBox = function(param) {
    var isReadOnly = param.isReadOnly;
    var _state_job, _state_job_quote, _state_job1, _state_job_quote1, _state_job2, _state_job3, _state_job4;
    var dispatch = useDispatch();
    var history = useHistory();
    var mergeProjectId = useSearchParam('mergeProjectId');
    var isVisibleFor2DMap = useRouteMatch([
        routes.order.root,
        routes.order.job()
    ]);
    var _useState = _sliced_to_array(useState(false), 2), expandInvoice = _useState[0], setExpandInvoice = _useState[1];
    var state = useContext(MapViewContext).state;
    var _useSelector = useSelector(function(reduxState) {
        return {
            currentUser: reduxState.profileReducer.userProfile,
            membershipPriceId: reduxState.order.membershipPriceId,
            mapState: reduxState.mapReducer
        };
    }), currentUser = _useSelector.currentUser, membershipPriceId = _useSelector.membershipPriceId, mapState = _useSelector.mapState;
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var handleSaveDraft = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(latestJob, values) {
            var force, _latestJob_project, data, job;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        force = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        data = _object_spread({
                            address: _object_spread({}, state.address),
                            message: state.requestMessage
                        }, values);
                        if (!((values === null || values === void 0 ? void 0 : values.projectName) && ((_latestJob_project = latestJob.project) === null || _latestJob_project === void 0 ? void 0 : _latestJob_project.id))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch(updateProjectName(latestJob.project.id, values.projectName, isAdmin))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            dispatch((latestJob === null || latestJob === void 0 ? void 0 : latestJob.id) ? updateJob(_object_spread_props(_object_spread({}, data), {
                                jobId: latestJob.id,
                                updatedAt: getNowDate(),
                                force: force,
                                onConflict: onShowForceSave
                            })) : createJob(data))
                        ];
                    case 3:
                        job = _state.sent();
                        return [
                            2,
                            job
                        ];
                }
            });
        });
        return function handleSaveDraft(latestJob, values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(job) {
            var params, redirectUrl;
            return _ts_generator(this, function(_state) {
                if (job) {
                    params = new URLSearchParams();
                    if (mergeProjectId) {
                        params.append('mergeProjectId', mergeProjectId);
                    }
                    redirectUrl = routes.payment.job(job.id);
                    if (isUserAnonymous(currentUser)) {
                        redirectUrl = routes.order.job(job.id);
                        params.append('alertType', ANONYMOUS_ORDER);
                        params.append('redirectUrl', redirectUrl);
                        history.push({
                            pathname: routes.login,
                            search: params.toString()
                        });
                    } else {
                        dispatch(sendLead(job.id, LEAD_CHECKOUT));
                        amplitudeTrack(PAYMENT_FLOW.EVENT, {
                            action: PAYMENT_FLOW.CHECKOUT_CART
                        });
                        history.push({
                            pathname: redirectUrl,
                            search: params.toString()
                        });
                    }
                }
                return [
                    2
                ];
            });
        });
        return function handleSubmit(job) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSaveDraft = function() {
        dispatch(showModal(SAVE_DRAFT_MODAL, {
            onSubmit: handleSaveDraft,
            currentUser: currentUser
        }));
    };
    var onSaveAndExit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var job;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.project.name) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleSaveDraft(state.job, {
                                projectName: state.project.name
                            })
                        ];
                    case 1:
                        job = _state.sent();
                        if (job) {
                            history.push(routes.home);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        onSaveDraft();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSaveAndExit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onForceSaveAndExit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var job;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleSaveDraft(state.job, {
                                projectName: state.project.name
                            }, true)
                        ];
                    case 1:
                        job = _state.sent();
                        if (job) {
                            history.push(routes.dashboard);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onForceSaveAndExit() {
            return _ref.apply(this, arguments);
        };
    }();
    var onShowForceSave = function() {
        dispatch(showModal(FORCE_JOB_UPDATE_MODAL, {
            onSubmit: onForceSaveAndExit
        }));
    };
    var isJobAwaitingPayment = [
        STATUS.COMMITTED,
        STATUS.AWAITING_PAYMENT
    ].includes((_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.status);
    var chargesHasTbc = useMemo(function() {
        var _state_job_quote, _state_job, _state_job_quote_charges, _state_job_quote1, _state_job1;
        var siteDeploymentFee = (_state_job = state.job) === null || _state_job === void 0 ? void 0 : (_state_job_quote = _state_job.quote) === null || _state_job_quote === void 0 ? void 0 : _state_job_quote.fees.find(function(fee) {
            return fee.id === 'site_deployment_fee';
        });
        var isSiteDeploymentFeeTBC = siteDeploymentFee && siteDeploymentFee.price.total === text('toBeConfirmed');
        return ((_state_job1 = state.job) === null || _state_job1 === void 0 ? void 0 : (_state_job_quote1 = _state_job1.quote) === null || _state_job_quote1 === void 0 ? void 0 : (_state_job_quote_charges = _state_job_quote1.charges) === null || _state_job_quote_charges === void 0 ? void 0 : _state_job_quote_charges.some(function(param) {
            var details = param.details;
            return [
                PRODUCT_TYPE.UNKNOWN
            ].includes(details.delivery_method);
        })) || isSiteDeploymentFeeTBC;
    }, [
        (_state_job1 = state.job) === null || _state_job1 === void 0 ? void 0 : (_state_job_quote = _state_job1.quote) === null || _state_job_quote === void 0 ? void 0 : _state_job_quote.charges,
        (_state_job2 = state.job) === null || _state_job2 === void 0 ? void 0 : (_state_job_quote1 = _state_job2.quote) === null || _state_job_quote1 === void 0 ? void 0 : _state_job_quote1.fees
    ]);
    var grandTotal = useMemo(function() {
        var _state_job;
        var quote = (_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.quote;
        var order;
        if (quote === null || quote === void 0 ? void 0 : quote.cart_totals) {
            // for new orders Sprint 67
            order = quote.cart_totals;
        } else if (quote === null || quote === void 0 ? void 0 : quote.order) {
            // released Sprint 66
            order = quote.order;
        } else {
            // old implementation
            // used quoted and completed orders
            order = quote;
        }
        return (order === null || order === void 0 ? void 0 : order.price.base) && !chargesHasTbc ? formatCurrency(isMembershipPriceId(membershipPriceId) && !isStaff(currentUser.role) ? order === null || order === void 0 ? void 0 : order.price.member_grand_total : order === null || order === void 0 ? void 0 : order.price.grand_total, quote === null || quote === void 0 ? void 0 : quote.currency.name, quote === null || quote === void 0 ? void 0 : quote.currency.scale_factor, {}, true) : text('toBeConfirmed');
    }, [
        chargesHasTbc,
        currentUser.role,
        membershipPriceId,
        (_state_job3 = state.job) === null || _state_job3 === void 0 ? void 0 : _state_job3.quote
    ]);
    // RESET membershipPriceId IF USER IS TRIAL
    useEffect(function() {
        if (currentUser && isStaff(currentUser.role) || userHasValidMembership(currentUser) && isUserUnderTrial(currentUser)) {
            dispatch(setMembershipPriceId(MEMBERSHIP.NO_MEMBERSHIP));
        }
    }, [
        currentUser,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('ExpandedCheckoutBox', {
            'read-only': isReadOnly,
            expanded: expandInvoice
        })
    }, ((_state_job4 = state.job) === null || _state_job4 === void 0 ? void 0 : _state_job4.quote) ? /*#__PURE__*/ React.createElement(ExpandedDetails, {
        membershipPriceId: membershipPriceId,
        toggleIcon: "caret-up",
        toggleInvoiceSummary: function() {
            return setExpandInvoice(!expandInvoice);
        },
        isInvoiceExpanded: expandInvoice,
        hasTbc: chargesHasTbc
    }) : null, /*#__PURE__*/ React.createElement("div", {
        className: "mb-2"
    }), !isReadOnly ? /*#__PURE__*/ React.createElement("div", {
        className: "expandedCheckoutBoxFooter"
    }, isVisibleFor2DMap ? /*#__PURE__*/ React.createElement(Button, {
        style: {
            width: 100
        },
        id: "dashboardButton",
        variant: "outline-primary",
        onClick: onSaveAndExit,
        disabled: state.isCartLoading
    }, text(mapState.isLoadingSmartSelections ? 'saving' : 'saveAndGoToDashboard')) : null, /*#__PURE__*/ React.createElement(Button, {
        id: "orderDataButton",
        "data-toggle": "modal",
        "data-target": "#purchase",
        onClick: function() {
            return handleSubmit(state.job);
        },
        disabled: state.isCartLoading
    }, "".concat(grandTotal, " - ").concat(text('checkout')))) : /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        onClick: function() {
            return history.push({
                pathname: isJobAwaitingPayment ? routes.payment.job(state.job.id) : routes.dashboard
            });
        }
    }, text(isJobAwaitingPayment ? 'payNow' : 'goToDashboard')));
};
export default ExpandableCheckoutBox;
